import { IValidation } from '../validation';

export interface IPolicyHoldersInput extends Record<string, unknown> {
  guid?: string;
  isPrimary?: boolean;
  isDependent?: boolean;
  age: number | null;
  isAmbiguous?: boolean;
  firstName?: string;
  lastName?: string;
  emailAddress?: string;
  phoneNumber?: string;
  day?: number;
  month?: number;
  year?: number;
  dateOfBirth?: string | null;
  validation?: IValidation;
  residentIdentifier?: string;
}

export const emptyPolicyHolder: IPolicyHoldersInput = {
  guid: '',
  isPrimary: false,
  isDependent: false,
  age: null,
  isAmbiguous: true,
  firstName: '',
  lastName: '',
  emailAddress: '',
  phoneNumber: '',
  day: 1,
  month: 1,
  year: 1,
  dateOfBirth: null,
  validation: {
    isValid: false,
    errors: [],
  },
  residentIdentifier: '',
};
